import { jsPDF } from "jspdf";

const PRIMARY = [0, 47, 167]; // #002FA7 Klein Blue
const ACCENT = [255, 215, 0]; // #FFD700
const BLACK = [10, 10, 10];
const GRAY = [134, 142, 150];

/**
 * Generate a subscription PDF with the user's pre-filled info (or blank fields to fill by hand).
 * Returns a jsPDF instance — caller may .save() or .output("blob").
 */
export function generateSubscriptionPDF(data = {}) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const W = 210;
  const M = 20;
  let y = 20;

  // Header bar
  doc.setFillColor(...BLACK);
  doc.rect(0, 0, W, 8, "F");
  doc.setFillColor(...ACCENT);
  doc.rect(0, 8, W, 2, "F");

  // Brand
  y = 22;
  doc.setFontSize(26);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...BLACK);
  doc.text("PAG", M, y);
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY);
  doc.text("BUSINESS MANAGER", M + 18, y - 3);
  doc.text("Groupe Parc Avenue", M + 18, y + 1);

  // Title block
  y = 44;
  doc.setFontSize(22);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(...BLACK);
  doc.text("Bulletin de souscription", M, y);
  y += 8;
  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(...GRAY);
  doc.text("Espace Entreprise PAG — Abonnement annuel", M, y);

  // Price callout
  y += 12;
  doc.setFillColor(...PRIMARY);
  doc.rect(M, y, 170, 18, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(9);
  doc.text("TARIF ABONNEMENT", M + 5, y + 6);
  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");
  doc.text("790,00 EUR / an", M + 5, y + 14);
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.text("Tout inclus : 3 portails - salaries illimites - support - formation incluse", M + 75, y + 14);

  // Section: Informations du souscripteur
  y += 26;
  sectionHeader(doc, "1. Informations du souscripteur", M, y);
  y += 8;
  y = field(doc, "Nom", data.nom, M, y, 85);
  field(doc, "Prénom", data.prenom, M + 90, y - 14, 80);
  y = field(doc, "Email professionnel", data.email, M, y, 85);
  field(doc, "Téléphone professionnel", data.telephone, M + 90, y - 14, 80);

  // Section: Informations de l'entreprise
  y += 4;
  sectionHeader(doc, "2. Informations de l'entreprise", M, y);
  y += 8;
  y = field(doc, "Raison sociale", data.entreprise, M, y, 170);
  y = field(doc, "SIRET / SIREN", data.siret, M, y, 85);
  field(doc, "Code NAF / APE", data.naf, M + 90, y - 14, 80);
  y = field(doc, "Adresse", data.adresse, M, y, 170);
  y = field(doc, "Code postal", data.code_postal, M, y, 40);
  field(doc, "Ville", data.ville, M + 45, y - 14, 60);
  field(doc, "Pays", data.pays || "France", M + 110, y - 14, 60);

  // Section: Engagement
  y += 4;
  sectionHeader(doc, "3. Engagement et signature", M, y);
  y += 8;
  doc.setFontSize(8.5);
  doc.setTextColor(...BLACK);
  doc.setFont("helvetica", "normal");
  const engagementText = [
    "Je soussigne(e) declare souscrire a l'abonnement annuel PAG Business Manager pour un",
    "montant de 790,00 EUR TTC par an. Je reconnais avoir pris connaissance des conditions",
    "generales d'utilisation et accepte le prelevement / virement a reception de facture.",
    "La formation d'initiation au logiciel est comprise dans l'abonnement.",
  ];
  engagementText.forEach((line) => { doc.text(line, M, y); y += 4.5; });

  y += 4;
  // Signature zone
  doc.setDrawColor(...GRAY);
  doc.rect(M, y, 80, 30);
  doc.rect(M + 90, y, 80, 30);
  doc.setFontSize(8);
  doc.setTextColor(...GRAY);
  doc.text("Fait a  _____________________  le  _____ / _____ / __________", M, y - 2);
  doc.text("Signature du souscripteur", M + 2, y + 34);
  doc.text("Cachet de l'entreprise", M + 92, y + 34);

  // Footer
  const footerY = 278;
  doc.setDrawColor(...BLACK);
  doc.setLineWidth(0.3);
  doc.line(M, footerY, W - M, footerY);
  doc.setFontSize(8);
  doc.setTextColor(...GRAY);
  doc.text("PAG Business Manager - Groupe Parc Avenue", M, footerY + 5);
  doc.text("contact@parcavenue.eu   |   09 70 70 17 92", M, footerY + 9);
  doc.setTextColor(...PRIMARY);
  doc.text("Merci de retourner ce document signe a contact@parcavenue.eu", M, footerY + 14);

  return doc;
}

function sectionHeader(doc, text, x, y) {
  doc.setFillColor(10, 10, 10);
  doc.rect(x, y - 4, 170, 6, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");
  doc.text(text.toUpperCase(), x + 2, y);
}

function field(doc, label, value, x, y, width) {
  doc.setFontSize(7.5);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(134, 142, 150);
  doc.text(label.toUpperCase(), x, y);
  doc.setDrawColor(222, 226, 230);
  doc.setLineWidth(0.3);
  doc.line(x, y + 8, x + width, y + 8);
  if (value) {
    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(10, 10, 10);
    doc.text(String(value), x, y + 6);
  }
  return y + 14;
}

/** Build the mailto URL with a pre-filled subscription message */
export function buildSubscriptionMailto(data = {}) {
  const subject = "Souscription PAG Business Manager - 790 EUR / an";
  const lines = [
    "Bonjour,",
    "",
    "Je souhaite souscrire à l'abonnement PAG Business Manager (790 EUR / an, tout inclus).",
    "Vous trouverez ci-joint le bulletin de souscription pré-rempli avec mes coordonnées.",
    "",
    "COORDONNÉES",
    "──────────────────────",
    `Nom :             ${data.nom || "________________________"}`,
    `Prénom :          ${data.prenom || "________________________"}`,
    `Email pro :       ${data.email || "________________________"}`,
    `Téléphone pro :   ${data.telephone || "________________________"}`,
    "",
    "ENTREPRISE",
    "──────────────────────",
    `Raison sociale :  ${data.entreprise || "________________________"}`,
    `SIRET / SIREN :   ${data.siret || "________________________"}`,
    `Adresse :         ${data.adresse || "________________________"}`,
    `Code postal :     ${data.code_postal || "__________"}`,
    `Ville :           ${data.ville || "________________________"}`,
    "",
    "Merci de me confirmer la procédure de paiement et la date de démarrage.",
    "",
    "Cordialement,",
    data.prenom && data.nom ? `${data.prenom} ${data.nom}` : "",
  ];
  const body = lines.join("\n");
  return `mailto:contact@parcavenue.eu?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

/** End-to-end: download PDF + open mailto */
export function triggerSubscription(data) {
  const doc = generateSubscriptionPDF(data);
  const filename = `bulletin-souscription-PAG${data.nom ? "-" + data.nom.toLowerCase().replace(/\s+/g, "-") : ""}.pdf`;
  doc.save(filename);
  // Slight delay so the save dialog opens before the mailto
  setTimeout(() => {
    window.location.href = buildSubscriptionMailto(data);
  }, 400);
}
